import React from "react";

const CreditNotePage = () => {
  return <div></div>;
};

export default CreditNotePage;
